import { StaffSurplusRefundRequest, StaffSurplusRefundResponse, StaffSurplusRefundReviewRequest } from "lib-klab-sdks";
import { SurplusRefund, SurplusRefundRequest, SurplusRefundReviewRequest } from "../../../domain/models/treasury/surplus-refund.model";

export function mapSurplusRefundRequest(request: SurplusRefundRequest): StaffSurplusRefundRequest {
  return { ...request };
}

export function mapSurplusRefund(response: StaffSurplusRefundResponse): SurplusRefund {
  return { ...response };
}

export function mapSurplusRefundReviewRequest(request: SurplusRefundReviewRequest): StaffSurplusRefundReviewRequest {
  return { ...request };
}
